<h2 mat-dialog-title>Cancel Pickup</h2>

<div mat-dialog-content>
  <p class="confirmation-message">
    Are you sure you want to cancel the pickup for: <strong>{{ data.assetName }}</strong> assigned to
    <strong>{{ data.driverName }}</strong
    >?
  </p>

  <mat-form-field class="full-width">
    <mat-label>Reason for cancellation</mat-label>
    <textarea matInput [(ngModel)]="reason" placeholder="Please provide a reason" rows="3"></textarea>
  </mat-form-field>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">No, Keep It</button>
  <button mat-raised-button color="warn" [disabled]="!reason.trim()" (click)="onConfirm()">Yes, Cancel Pickup</button>
</div>
